module.exports = __webpack_public_path__ + "static/media/bottled-beer.220ca451.png";